/* KASUMI pond fogger page. Native cart drawer, free gift sync, kit selector, gallery, fit checker, before and after. */
(() => {
  const D = document, H = D.documentElement;
  H.classList.add('ksm-js');
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = () => (reduce() ? 'auto' : 'smooth');
  const root_ = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Shipping dates: order today, shipped +2, delivered +7 to +10 calendar days, local time. */
  function fmtRange(now, start, end, locale) {
    const day = n => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + ' to ' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = H.lang || 'en-US';
    D.querySelectorAll('[data-ksm-ship-date]').forEach(el => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  addEventListener('pageshow', updateShipDates);
  D.addEventListener('visibilitychange', () => { if (!D.hidden) updateShipDates(); });

  /* Free gift: one gift line while a KASUMI kit is in the cart, made free by the gift code. */
  const Gift = (() => {
    let cfg = null, pending = null;
    async function req(path, body, tries = 2) {
      const r = await fetch(root_() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch (e) {
        if (tries > 1) { await new Promise(z => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req('cart.js');
      const isKit = i => cfg.packs.includes(Number(i.variant_id));
      const gifts = cart.items.filter(i => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isKit) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map(d => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter(c => c.toUpperCase() !== own);
      const applied = codes.some(c => c.toUpperCase() === own);
      const free = gifts.every(i => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => { updates[g.key] = k === 0 ? want : 0; });
      else if (want) updates[cfg.gift] = want;
      const drawer = D.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender && drawer.getSectionsToRender().map(s => s.id)) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter(i => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {}; charged.forEach(i => { rm[i.key] = 0; });
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your fogger is in the cart, but the free spare discs could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return { set(c) { cfg = c; }, sync() { if (!pending) pending = reconcile().finally(() => { pending = null; }); return pending; } };
  })();
  window.KsmGift = Gift;

  function initReveal() {
    const secs = D.querySelectorAll('.ks-s[data-ksm-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach(s => io.observe(s));
    } else secs.forEach(s => s.classList.add('is-in'));
    const catchUp = () => secs.forEach(s => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  function init() {
    updateShipDates();
    initReveal();
    const root = D.querySelector('#ksm');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.ks-proof .ceyla-rproof__text').forEach(p => p.childNodes.forEach(n => { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; }));

    const money = c => new Intl.NumberFormat(H.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const tiers = [...root.querySelectorAll('[name="ksm-tier"]')];
    const addons = [...root.querySelectorAll('[data-ksm-addon]')];
    const tierInfo = t => {
      const r = tiers.find(x => x.value === String(t)) || tiers[0];
      return { r, variant: Number(r.dataset.variant), price: Number(r.dataset.price), compare: Number(r.dataset.compare || 0), media: r.dataset.media, available: r.dataset.available === 'true' };
    };
    Gift.set({ packs: tiers.map(r => Number(r.dataset.variant)), gift: Number(root.dataset.giftVariant) || 0, code: root.dataset.giftCode || 'KASUMIGIFT' });

    /* Gallery with thumbnails on every screen size. */
    const g = root.querySelector('[data-ksm-gallery]');
    const slides = [...g.querySelectorAll('.ks-slide')];
    const thumbs = [...root.querySelectorAll('.ks-thumb')];
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-ksm-slide]').forEach(b => b.addEventListener('click', () => to(Number(b.dataset.ksmSlide))));
    const nx = root.querySelector('[data-ksm-next]'), pv = root.querySelector('[data-ksm-prev]');
    if (nx) nx.addEventListener('click', () => to(idx() + 1));
    if (pv) pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx();
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
        const at = thumbs[i], row = at && at.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: at.offsetLeft - row.clientWidth / 2 + at.clientWidth / 2, behavior: smooth() });
        slides.forEach((sl, j) => { const v = sl.querySelector('video'); if (v) { if (j === i) v.play().catch(() => {}); else v.pause(); } });
      });
    }, { passive: true });
    g.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); } });
    const firstVid = g.querySelector('video'); if (firstVid) { firstVid.muted = true; firstVid.play().catch(() => {}); }

    /* Kit selector: live price, savings, add-on rows, gallery and button total. */
    let tier = Number(root.dataset.tier) || 2;
    const termsId = root.querySelector('[data-ksm-terms-id]');
    const addonTotal = () => addons.reduce((n, a) => n + (a.checked && !a.closest('[data-ksm-addon-row]').hidden ? Number(a.dataset.price) : 0), 0);
    const paint = fromUser => {
      const t = tierInfo(tier);
      tiers.forEach(r => { r.checked = r.value === String(tier); r.closest('.ks-kit').classList.toggle('is-on', r.checked); });
      root.querySelectorAll('[data-ksm-addon-row]').forEach(row => {
        const show = (row.dataset.tiers || '').split(',').map(x => x.trim()).includes(String(tier));
        row.hidden = !show;
        if (!show) { const cb = row.querySelector('input'); if (cb) cb.checked = false; }
      });
      const ah = root.querySelector('.ks-addons'); if (ah) ah.hidden = !root.querySelector('[data-ksm-addon-row]:not([hidden])');
      const set = (sel, v) => { const el = root.querySelector(sel); if (el) el.textContent = v; };
      set('[data-ksm-price]', money(t.price));
      const c = root.querySelector('[data-ksm-compare]'), s = root.querySelector('[data-ksm-save]');
      if (t.compare > t.price) { c.hidden = false; s.hidden = false; c.textContent = money(t.compare); s.textContent = 'Save ' + money(t.compare - t.price).replace(/\.00(?=\D*$)/, ''); }
      else { c.hidden = true; s.hidden = true; }
      const total = t.price + addonTotal();
      D.querySelectorAll('[data-ksm-atc-total]').forEach(el => { el.textContent = money(total); });
      const sp = D.querySelector('[data-ksm-sticky-price]'); if (sp) sp.textContent = money(total);
      if (termsId && termsId.value !== String(t.variant)) { termsId.value = t.variant; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      const main = root.querySelector('.ks-atc[data-ksm-add]'); if (main) main.disabled = !t.available;
      D.querySelectorAll('[data-ksm-kit-pick]').forEach(b => {
        const on = tier >= Number(b.dataset.ksmKitPick);
        b.setAttribute('aria-pressed', String(on));
        const sp2 = b.querySelector('span'); if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off;
      });
      if (fromUser) {
        if (t.variant) { const u = new URL(location.href); u.searchParams.set('variant', t.variant); history.replaceState(history.state, '', u); }
        if (t.media) { const si = slides.findIndex(sl => sl.dataset.mediaId === t.media); if (si >= 0 && root.querySelector('.ks-buy').getBoundingClientRect().top < innerHeight) to(si); }
        const card = t.r.closest('.ks-kit');
        if (card && !reduce()) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      }
    };
    tiers.forEach(r => r.addEventListener('change', () => { tier = Number(r.value); paint(true); }));
    addons.forEach(a => a.addEventListener('change', () => paint(false)));
    D.querySelectorAll('[data-ksm-kit-pick]').forEach(b => b.addEventListener('click', () => {
      const want = Number(b.dataset.ksmKitPick);
      tier = tier >= want ? want - 1 : want;
      paint(true);
    }));
    paint(false);
    addEventListener('pageshow', () => paint(false));

    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = D.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = n => root.querySelectorAll('[data-ksm-count]').forEach(e => { e.textContent = n; });
    const vipFirst = () => {
      const sheet = D.querySelector('.vf-root'), bag = D.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach(p => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => { if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(p => bag.style.removeProperty(p)); } }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget, t = tierInfo(tier);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...D.querySelectorAll('[data-ksm-add]')];
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-ksm-error]'); err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map(s => s.id);
        const items = [{ id: t.variant, quantity: 1 }];
        addons.forEach(a => { if (a.checked && !a.closest('[data-ksm-addon-row]').hidden) items.push({ id: Number(a.dataset.variant), quantity: 1 }); });
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your fogger could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your fogger could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(root_() + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach(b => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    D.querySelectorAll('[data-ksm-add]').forEach(b => b.addEventListener('click', add));
    root.querySelectorAll('[data-ksm-cart]').forEach(b => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map(s => s.id);
        const [sections, c] = await Promise.all([fetch(root_() + '?sections=' + ids.join(',')).then(r => r.json()), fetch(root_() + 'cart.js').then(r => r.json())]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-ksm-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__ksmSync);
        window.__ksmSync = setTimeout(() => Gift.sync().then(c => c && setCount(c.item_count)).catch(x => { const e = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-ksm-error]'); if (e) e.textContent = x.message; }), 150);
      });
    }
    const nd = D.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0)); else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    D.addEventListener('click', e => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.ksmReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Gift.sync().then(() => { const n = D.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.ksmReady = '1'; n.click(); delete n.dataset.ksmReady; })
        .catch(x => { const el = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-ksm-error]'); if (el) el.textContent = x.message; });
    }, true);
    Gift.sync().then(c => c && setCount(c.item_count)).catch(() => {});

    const dlg = D.querySelector('#ksm-policy');
    if (dlg) {
      D.querySelectorAll('[data-ksm-policy]').forEach(b => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-ksm-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    }
    const cBan = D.querySelector('.ks-banner'), cPill = D.querySelector('.ks-concept-pill');
    if (cPill) { if (cBan && 'IntersectionObserver' in window) new IntersectionObserver(es => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan); else cPill.classList.add('is-on'); }
    const sticky = D.querySelector('[data-ksm-sticky]'), buy = root.querySelector('.ks-buy .ks-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => { cancelAnimationFrame(sraf); sraf = requestAnimationFrame(() => { const show = buy.getBoundingClientRect().bottom < 0; sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', String(!show)); sticky.querySelector('button').tabIndex = show ? 0 : -1; }); };
      addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
    }
  }

  function widgets() {
    D.querySelectorAll('[data-ksm-fit]').forEach(f => {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fx]')], ans = [...f.querySelectorAll('[data-fx-ans]')];
      tabs.forEach(b => b.addEventListener('click', () => {
        tabs.forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        ans.forEach(a => { a.hidden = a.dataset.fxAns !== b.dataset.fx; });
      }));
    });
    D.querySelectorAll('[data-ksm-ba]').forEach(ba => {
      if (ba.dataset.ready) return; ba.dataset.ready = '1';
      const r = ba.querySelector('[data-ksm-ba-range]');
      const setv = v => ba.style.setProperty('--pos', v + '%');
      r.addEventListener('input', () => setv(r.value)); setv(r.value);
      if (!reduce() && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { io.disconnect(); let v = 50, dir = 1, n = 0; const tm = setInterval(() => { v += dir * 2; if (v >= 78) dir = -1; if (v <= 50 && dir < 0) { clearInterval(tm); v = 50; } r.value = v; setv(v); if (++n > 80) clearInterval(tm); }, 16); } }, { threshold: 0.5 });
        io.observe(ba);
      }
    });
  }
  const boot = () => { init(); widgets(); };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', () => { updateShipDates(); widgets(); D.querySelectorAll('.ks-s[data-ksm-reveal]').forEach(s => s.classList.add('is-in')); });
})();
